import ImgUrl from './rs.PNG';
import PdUrl from "./pd.PNG";

export const ProjectData = [
  {
    id: 1,
    title: "Reponsive Product Directory",
    about:
      "I designed an amazing project currently been used by over 5000 user daily",
    tags: ["ReactJS", "Javascript", "Api", "Portfolio"],
    demo: "https://productdirectory.netlify.app/",
    github: "https://github.com/Efe-Roy/prodoctDirectory.git",
    image: PdUrl,
  },
  {
    id: 2,
    title: "Real Estate Website",
    about:
      "Sample Real Estate project I builded using React.JS, Javascript, HTML/CSS.",
    tags: ["ReactJS", "Html/Css"],
    demo: "https://real-estatee.netlify.app/",

    // url: "https://www.gregoryjaccottet.com",
    // github: "https://github.com/Efe-Roy/WebConsomeTerminal.git",
    image: ImgUrl,
  },
];